import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { SeverityLevel } from '@microsoft/applicationinsights-common';

@Injectable({
    providedIn: 'root'
})
export class ApplicationInsightsService {
    private readonly appInsights?: ApplicationInsights;

    constructor() {
        if (!environment.appInsightsConnectionString || environment.appInsightsConnectionString.trim() === '') {
            return;
        }

        this.appInsights = new ApplicationInsights({
            config: {
                connectionString: environment.appInsightsConnectionString,
                enableAutoRouteTracking: true
            }
        });

        this.appInsights.loadAppInsights();
    }

    trackTrace(
        message: string,
        severityLevel: SeverityLevel,
        properties?: Record<string, string>
    ): void {
        this.appInsights?.trackTrace({
            message,
            severityLevel,
            properties: {
                environment: environment.name,
                application: 'Angular',
                ...properties
            }
        });
    }

    trackException(
        error: Error,
        properties?: Record<string, string>
    ): void {
        this.appInsights?.trackException({
            exception: error,
            properties: {
                environment: environment.name,
                application: 'Angular',
                ...properties
            }
        });
    }
}
